import { InputText } from "@2solve/tosolve-inputs";
import { useEffect, useState } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import useApi from "../../hooks/apiService";
import Atributos from "../register/attributes/attributes";
import Features from "./features/features";
import Brokers from "./brokers/broker";
import Logs from "../logs/logs";
import CodecsHeader from "./codecs/codecs";
import { useTranslation } from "react-i18next";

export default function AdminDashboard() {
  const { postData } = useApi();
  const [authorized, setAuthorized] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [attempts, setAttempts] = useState(0);
  const [error, setError] = useState("");
  const [view, setView] = useState("attributes");
  const { t } = useTranslation();

  useEffect(() => {
    if (localStorage.getItem("token") === null) {
      window.location.href = "/";
      return;
    }
    if (sessionStorage.getItem("superAdmAuth") === "true") {
      setAuthorized(true);
    } else {
      setShowModal(true);
    }
  }, []);

  const handleLogin = async (event) => {
    event.preventDefault();
    setError("");

    try {
      const response = await postData("/super-admin/login", { user, password });

      const ok =
        response?.data?.status === "success" ||
        response?.status === "success" ||
        response?.data?.success === true;

      if (!ok) throw new Error("Login não autorizado.");

      sessionStorage.setItem("superAdmAuth", "true");
      setAuthorized(true);
      setShowModal(false);
      setUser("");
      setPassword("");
      setAttempts(0);
    } catch (e) {
      const newAttempts = attempts + 1;
      setAttempts(newAttempts);

      setError(`${normalizeError(e)} (Tentativa ${newAttempts} de 3.)`);

      if (newAttempts >= 3) {
        alert("Acesso negado. Você será redirecionado.");
        window.location.href = "/";
      }
    }
  };

  const normalizeError = (e) => {
    const data = e?.response?.data;

    if (data?.detail) {
      if (typeof data.detail === "string") return data.detail;

      if (Array.isArray(data.detail)) {
        return data.detail
          .map((it) => it?.msg || JSON.stringify(it))
          .join(" | ");
      }

      return data.detail?.msg || JSON.stringify(data.detail);
    }

    if (typeof data?.message === "string") return data.message;

    if (typeof e?.message === "string") return e.message;

    return "Erro inesperado.";
  };

  if (!authorized) {
    return (
      <Modal show={showModal} backdrop="static" centered>
        <Modal.Header>
          <Modal.Title>{t("admin_access")}</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleLogin}>
          <Modal.Body>
            <InputText
              type="text"
              value={user}
              onChange={(_, value) => setUser(value)}
              placeholder="Usuário"
              autoFocus
              autoComplete="off"
            />
            <InputText
              className="mt-3"
              type="password"
              value={password}
              onChange={(_, value) => setPassword(value)}
              placeholder="Senha"
              autoComplete="new-password"
            />
            {error && <Alert variant="danger">{error}</Alert>}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                window.location.href = "/";
              }}
            >
              {t("button_cancel")}
            </Button>
            <Button variant="primary" type="submit">
              {t("button_login")}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  }

  return (
    <div className="p-4">
      <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
        <Button
          variant={view === "attributes" ? "primary" : "outline-primary"}
          onClick={() => setView("attributes")}
        >
          {t("attributes")}
        </Button>
        <Button
          variant={view === "features" ? "primary" : "outline-primary"}
          onClick={() => setView("features")}
        >
          {t("features")}
        </Button>
        <Button
          variant={view === "brokers" ? "primary" : "outline-primary"}
          onClick={() => setView("brokers")}
        >
          {t("brokers")}
        </Button>
        <Button
          variant={view === "codec" ? "primary" : "outline-primary"}
          onClick={() => setView("codec")}
        >
          {t("codec")}
        </Button>
        <Button
          variant={view === "logs" ? "primary" : "outline-primary"}
          onClick={() => setView("logs")}
        >
          {t("logs")}
        </Button>
      </div>
      {view === "attributes" && <Atributos disableLocking={true} />}
      {view === "features" && <Features />}
      {view === "brokers" && <Brokers />}
      {view === "codec" && <CodecsHeader />}
      {view === "logs" && <Logs isAdminView />}
    </div>
  );
}
